(function () {
  if (window.__egohomeSizeGuideInit) return;
  window.__egohomeSizeGuideInit = true;

  let scrollLockCount = 0;

  function lockScroll() {
    scrollLockCount += 1;
    document.documentElement.style.overflow = 'hidden';
  }

  function unlockScroll() {
    scrollLockCount = Math.max(0, scrollLockCount - 1);
    if (scrollLockCount === 0) {
      document.documentElement.style.overflow = '';
    }
  }

  function openDialog(trigger) {
    const wrap = trigger.closest('[data-egohome-size-guide-wrap]');
    if (!wrap) return;

    let dialog = wrap.querySelector('[data-egohome-size-guide]');
    if (!dialog) return;

    if (dialog.parentElement !== document.body) {
      document.body.appendChild(dialog);
    }

    dialog.classList.add('is-open');
    dialog.setAttribute('aria-hidden', 'false');
    lockScroll();
  }

  function closeDialog(dialog) {
    if (!dialog) return;
    dialog.classList.remove('is-open');
    dialog.setAttribute('aria-hidden', 'true');
    unlockScroll();
  }

  function switchTab(tab) {
    const content = tab.closest('[data-egohome-size-guide-content]');
    if (!content) return;

    const target = tab.getAttribute('data-target');
    content.querySelectorAll('[data-egohome-size-guide-tab]').forEach((item) => {
      item.classList.toggle('is-active', item === tab);
    });
    content.querySelectorAll('[data-egohome-size-guide-panel]').forEach((panel) => {
      panel.classList.toggle('is-active', panel.getAttribute('data-panel') === target);
    });
  }

  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest('[data-egohome-size-guide-open]');
    if (openTrigger) {
      event.preventDefault();
      openDialog(openTrigger);
      return;
    }

    const closeBtn = event.target.closest('[data-egohome-size-guide-close]');
    if (closeBtn) {
      closeDialog(closeBtn.closest('[data-egohome-size-guide]'));
      return;
    }

    const dialog = event.target.closest('[data-egohome-size-guide]');
    if (dialog && event.target === dialog) {
      closeDialog(dialog);
      return;
    }

    const tab = event.target.closest('[data-egohome-size-guide-tab]');
    if (tab) {
      switchTab(tab);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-egohome-size-guide].is-open').forEach((dialog) => {
      closeDialog(dialog);
    });
  });
})();
